var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31126 13.6154L11.1851 6.30459C11.3766 6.01738 11.299 5.62934 11.0118 5.43787C10.9091 5.36942 10.7885 5.3329 10.6651 5.3329H6.83289V0.730469C6.83289 0.385291 6.55307 0.105469 6.20789 0.105469C5.99892 0.105469 5.80378 0.209907 5.68786 0.383781L0.814019 7.69455C0.622549 7.98175 0.700158 8.36979 0.987363 8.56126C1.09003 8.62971 1.21066 8.66623 1.33405 8.66623H5.16623V13.2687C5.16623 13.6138 5.44605 13.8937 5.79123 13.8937C6.0002 13.8937 6.19534 13.7892 6.31126 13.6154Z",
    fill: "#6BEF78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.c3c05b3471ad295745359f4d5acb705c.svg";
export { ForwardRef as ReactComponent };